export class MercadoriasEmbalagensModel {
  id_embalagem: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-embalagens/mercadorias-embalagens.model.ts